/* eslint-disable radix */
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import useAuth from "../../hooks/useAuth";
import { getDefaultAuthorizedRoute } from "../../utils/common";
import { memo } from "react";

const AuthGuard = ({ children }) => {
  const { isAuthenticated, user, accessType } = useAuth();
  // console.log("isAuthenticated", isAuthenticated, user, accessType);
  const location = useLocation();
  const navigate = useNavigate();

  if (location.pathname != "/bot-settings") {
    localStorage.removeItem("chatSource");
    localStorage.removeItem("botStyle");
    localStorage.removeItem("botWorkFlowEdge");
    localStorage.removeItem("botWorkFlowNode");
    localStorage.removeItem("chatElement");
    localStorage.removeItem("chatNode");
  }

  if (!isAuthenticated && user === null) {
    if (!!localStorage.getItem("agency")) {
      navigate(`/?agency=${localStorage.getItem("agency")}`);
    }
    return <Navigate to="/" />;
  }

  if (user && accessType == 1) {
    return <Navigate to={getDefaultAuthorizedRoute(user, accessType)} />;
  }

  if (user && accessType === 3) {
    return <Navigate to={getDefaultAuthorizedRoute(user, accessType)} />;
  }

  if (user && accessType === 5) {
    return <Navigate to={getDefaultAuthorizedRoute(user, accessType)} />;
  }

  return <>{children}</>;
};

AuthGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default memo(AuthGuard);
